import { EInHomeProductCategory, ProductCategory } from 'api/types/product';
import { EPriceType } from 'components/NewProductStepper/ProductBaseForm/constants';
export const getProductCategory = ({
  category,
}: {
  category: ProductCategory | EInHomeProductCategory;
}) => {
  if (category === EInHomeProductCategory.IH_WITH_DATE) {
    return ProductCategory.IH;
  } else if (category === EInHomeProductCategory.IH_WITHOUT_DATE) {
    return ProductCategory.IH;
  }

  return category;
};

export const getProductPriceType = ({ price, priceType }) => {
  if (priceType) {
    return priceType;
  } else if (price) {
    return EPriceType.STATIC;
  }
};
